<div class="label-input label-sm mr-3">
  {{ 'signals-ng-visualization-tab.configPanel.groupBy' | translate }}
</div>
<ng-select class="ui2-dropdown selector" [clearable]="false" [items]="itemList" [(ngModel)]="model" (change)="select($event)">
  <ng-template ng-option-tmp ng-label-tmp let-item="item">
    {{ 'signals-ng-visualization-tab.propertyLabels.' + item?.type | translate }}
  </ng-template>
</ng-select>
